import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { toast } from 'react-toastify';

export default function MealPlanEditPage() {
  const { id } = useParams();
  const [mealPlan, setMealPlan] = useState(null);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get(`/mealplans/${id}`)
      .then((res) => {
        setMealPlan(res.data);
        setName(res.data.name);
      });
  }, [id]);

  const saveName = async () => {
    setSaving(true);
    try {
      const res = await apiClient.patch(
        `/mealplans/edit/${id}`,
        { name }
      );
      //setMealPlan(res.data);
    } catch (err) {
      console.error("Failed to update name", err);
    } finally {
      setSaving(false);
      toast.success("Name updated!");
    }
  };

  const deleteMealPlan = async () => {
    if (window.confirm("Are you sure you want to delete this meal plan?")) {
      await apiClient.delete(`/mealplans/${id}`);
      navigate("/mealplans"); // or wherever you want to send them
    }
  };

  const removeRecipe = async (recipeId) => {
    await apiClient.delete(`/mealplans/${id}/${recipeId}`);
    setMealPlan((prev) => ({
      ...prev,
      recipes: prev.recipes.filter((r) => r._id !== recipeId),
    }));
  };

  if (!mealPlan) return <p className="text-center mt-10">Loading meal plan...</p>;

  return (
    <div className="max-w-3xl mx-auto px-4 mt-10 space-y-6">
      {/* Editable Title */}
      <div className="flex items-center gap-2">
        <input
          type="text"
          className="text-2xl font-bold border-b border-gray-300 focus:outline-none focus:border-sage px-2 py-1 w-full"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button
          onClick={saveName}
          disabled={saving}
          className="bg-sage text-white text-sm px-3 py-1 rounded disabled:opacity-50"
        >
          Save
        </button>
      </div>

      {/* Recipes */}
      {mealPlan.recipes.map((recipe) => (
        <div
          key={recipe._id}
          className="border rounded p-4 bg-white shadow space-y-2"
        >
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">{recipe.name}</h2>
            <button
              onClick={() => removeRecipe(recipe._id)}
              title="Remove Recipe"
              className="p-2 rounded-full text-gray-400 text-sm hover:scale-105 transition hover:text-red-600"
            >
              <p>Remove</p>
            </button>
          </div>
          <p className="text-sm text-gray-600 italic">{recipe.summary}</p>

        </div>
      ))}

      <div>
        <button onClick={deleteMealPlan} 
            title="Delete Meal Plan" 
            className="bg-red-600 w-full text-white text-sm px-3 py-1 rounded">
            Delete mealplan
        </button>
      </div>
    </div>
  );
}
